export function fromPairs(tuples) {
    return tuples.reduce(function (acc, curr) {
        if (curr && curr.length === 2) {
            acc[curr[0]] = curr[1];
        }
        return acc;
    }, {});
}
